import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const WarningBox = ({setWarningShownOnce, openWarning, setOpenWarning}:any) =>{
    return(
        <Dialog open={openWarning} onClose={()=> setOpenWarning(false)} hideBackdrop={false}>
        <DialogTitle sx={{ color: 'error.main', fontWeight: 'bold' }}>
        Warning
      </DialogTitle>
      <DialogContent>
        <Typography>
          If you go back, all your entered data will be lost.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenWarning(false)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => { setWarningShownOnce(false); setOpenWarning(false); window.history.back();}}
        >
          OK
        </Button>
      </DialogActions>
      </Dialog>
    )
}

export {WarningBox};